import { paramsToQuery } from '@/base/MaUtils.js'
import { makeRequest } from '@/base/MaRequestPooler.js'

export function getAppStoreTopFeaturedApps({ categoryId, startDate, endDate, countryCode, targetDevice, trackId }, axiosCfg = {}) {
  const query = paramsToQuery({ startDate, endDate, countryCode, targetDevice, trackId })

  return makeRequest(`/categoryrankings/featured-apps/app-store/${categoryId}/tops?${query}`, axiosCfg)
}

export function getAppStoreFeaturedAppsCard({ categoryId, date, countryCode, targetDevice, trackId }) {
  const query = paramsToQuery({ date, countryCode, targetDevice, trackId })

  return makeRequest(`/categoryrankings/featured-apps/app-store/${categoryId}/cards?${query}`)
}

export function getPlayStoreTopFeaturedAppsCard({ countryCode, categoryId, startDate, endDate, trackId }, axiosCfg = {}) {
  const query = paramsToQuery({ countryCode, categoryId, startDate, endDate, trackId })

  return makeRequest(`/categoryrankings/featured-apps/play/${categoryId}/tops?${query}`, axiosCfg)
}

export function getPlayStoreFeaturedAppsCard({ countryCode, categoryId, ageId, date, trackId }) {
  const query = paramsToQuery({ countryCode, ageId, date, trackId })

  return makeRequest(`/categoryrankings/featured-apps/play/${categoryId}/cards?${query}`)
}

export function getFeaturedAppDetails({ trackId, countryCode, startDate, endDate }) {
  return makeRequest(`/categoryrankings/featured-apps/light/${trackId}?countryCode=${countryCode}&startDate=${startDate}&endDate=${endDate}`)
}

export function get({ trackId, startDate, endDate }, optionalParams) {
  const queryParams = Object.assign({ startDate, endDate }, optionalParams)
  return makeRequest(`/categoryrankings/app/${trackId}?${paramsToQuery(queryParams)}`)
}

export function getWithRank(trackId, store, countryCode, rankingType, device, date) {
  return makeRequest(`/categoryrankings/app/${trackId}/${store}/${countryCode}/${rankingType}?device=${device}&date=${date}`)
}

export function fetchCategoryRankingBulk({ countryCode, device, trackIds, startDate, endDate, rankings }) {
  const queryParams = {
    startDate,
    endDate,
    rankings,
  }
  return makeRequest(`/categoryrankings/bulk/${countryCode}/${device}?${paramsToQuery(queryParams)}`, {
    method: 'POST',
    data: { trackIds },
  })
}
